import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box, Typography, Grid, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, CircularProgress, Alert
} from '@mui/material';
import { anonymousService } from '../../services/anonymousService';
import AnonymousDetail from './AnonymousDetail';

const AnonymousList = () => {
  const { project } = useParams();
  const [visitors, setVisitors] = useState([]);
  const [selectedVisitor, setSelectedVisitor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVisitors = async () => {
      try {
        setLoading(true);
        const data = await anonymousService.getAnonymousVisitors(project);
        setVisitors(data);
        if (data.length > 0) {
          setSelectedVisitor(data[0]); // Auto-select first visitor
        }
      } catch (err) {
        console.error('Error fetching visitors:', err);
        setError('Failed to load visitors.');
      } finally {
        setLoading(false);
      }
    };

    if (project) {
      fetchVisitors();
    }
  }, [project]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Anonymous Visitors
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 4 }}>{error}</Alert>}

      <Grid container spacing={3}>
        {/* Left Side: Visitor List Table */}
        <Grid item xs={12} md={7}>
          <TableContainer component={Paper} sx={{ maxHeight: '70vh' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell><strong>IP Address</strong></TableCell>
                  <TableCell><strong>Country</strong></TableCell>
                  <TableCell><strong>Created At</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {visitors.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center">No visitors found</TableCell>
                  </TableRow>
                ) : (
                  visitors.map((visitor) => (
                    <TableRow
                      key={visitor._id}
                      hover
                      onClick={() => setSelectedVisitor(visitor)}
                      selected={selectedVisitor?._id === visitor._id}
                      sx={{ cursor: 'pointer' }}
                    >
                      <TableCell>{visitor.visitorinfo?.ip || 'Unknown'}</TableCell>
                      <TableCell>{visitor.visitorinfo?.country_name || 'N/A'}</TableCell>
                      <TableCell>{new Date(visitor.created || visitor.created_at).toLocaleDateString()}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        {/* Right Side: Visitor Details */}
        <Grid item xs={12} md={5}>
          <AnonymousDetail visitor={selectedVisitor} activities={[]} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AnonymousList;
